import React from 'react';
import { StyleSheet, css } from 'aphrodite';

// import {Link} from 'react-router-dom';
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

// import { arrowRight } from '@material-ui/icons';
import SvgIcon from '@material-ui/core/SvgIcon';
import AnchorLink from 'react-anchor-link-smooth-scroll'

    
export default class IntroContent extends React.Component{
    render(){
        return(
        <section className={css(styles.introSection)}>
        	<Grid container className="container">
                <Grid item md={6} xs={12} className={css(styles.container)}>
                    <Typography 
                    gutterBottom 
                    variant="display2"
                    className={css(styles.text, styles.title)}>
                    INNOVATIVE SOLUTIONS
                    </Typography>
                    <Typography 
                    gutterBottom 
                    variant="headline"
                    className={css(styles.text, styles.subtitle)}>
                    Innovation | Software | Hardware | Graphics
                    </Typography>
                    <Typography 
                    variant="subheading" 
                    className={css(styles.text, styles.paragraph)}>
                    We are a team of hackers, artists and innovators 
                    </Typography>
                    <AnchorLink offset="-170" href='#CoolStuff' style={{textDecoration: 'none'}}>
                    <Button className={css(styles.introButton)}>
                        <Grid style={{marginLeft: 20}} container direction="row" alignItems="center" justify="space-between">
                            <Grid item>
                            Learn More 
                            </Grid>
                                <Grid item>
                                    <SvgIcon className={css(styles.rightArrow)}>
                                        <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
                                    </SvgIcon> 
                                </Grid>
                        </Grid>
                    </Button>
                    </AnchorLink>
                </Grid>
            </Grid>
        </section>
    )
  }
  }



const styles = StyleSheet.create({
    introSection: {
        minHeight: '90vh'
    },
    container: {
        paddingTop: '15%',
        color: 'white',
        '@media (max-width: 768px)' :{
            paddingTop: '35%',
        }
    },
    text: {
        color: '#fff',
        '@media (max-width: 768px)': {
            marginBottom: '5%'
        }
    },
    title: {
        fontWeight: 500,
    },
    subtitle: {

    },
    paragraph: {
    
    },
    introButton: {
        color: 'white',
        width: 180,
        background: 'linear-gradient(-161deg, #FF6B4D, #D85944)',
        borderRadius: 200,
        lineHeight: 0,
        paddingRight: '10px',
        marginTop: '5%',
        boxShadow: '0 18px 35px rgba(50,50,93,.1), 0 8px 15px rgba(0,0,0,.07)',
        transition: 'all ease-in-out .2s',
        ':hover':{
            transform: 'translate(0, -2px)',
            boxShadow: '0 20px 40px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
    rightArrow: {
        backgroundColor: '#F7FCFF',
        color: '#7047D6',
        borderRadius: '188px',
        fontSize: '31px',
        padding: '5px',
        marginLeft: '15px'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/Intro/IntroContent.js